import { useState, useMemo, useEffect } from "react";
import Modal from "../../../../../wp-utils/v1/components/Modal/Modal";
import { useWPAjax } from "../../../../../wp-utils/v1";
import RegistrationForm from "../../../frontend/registration-form/RegistrationForm";
import { sortJsonArrayAlphabetically } from "../../../frontend/registration-form/fields/Address";
import ApplicationForm from "./ApplicationForm";

const MemberModal = ({ open, setOpen, member = {}, nonce, fields = [], refetch, editable, setEditable, auth, page }) => {
  const [formData, setFormData] = useState(member || {});
  const [error, setError] = useState(null);
  const [notice, setNotice] = useState(null);

  const { data, isLoading, error: phpError } = useWPAjax("ajax_request_handler", { nonce, model: "Users", method: "create_account" }, true);
  const { isLoading: approval_running, saveData, error: approvalError } = useWPAjax("ajax_request_handler", { method: "update_user_data_ajax", model: "Users", nonce }, true);
  const [loading, setLoading] = useState(null);

  const [districtList, setDistrictList] = useState([]);
  const [thanaList, setThanaList] = useState([]);
  const [isApproved, setIsApproved] = useState(false);

  useEffect(() => {
    if (!districtList || districtList?.length < 1) {
      fetch("https://raw.githubusercontent.com/shehabulislam/bangladesh-geojson/master/bd-districts.json")
        .then((res) => res.json())
        .then((res) => {
          setDistrictList(sortJsonArrayAlphabetically(res.districts));
        });
    }
    if (!thanaList || thanaList?.length < 1) {
      fetch("https://raw.githubusercontent.com/shehabulislam/bangladesh-geojson/master/bd-upazilas.min.json")
        .then((res) => res.json())
        .then((res) => setThanaList(sortJsonArrayAlphabetically(res)));
    }
  }, []);

  const requiredFields = useMemo(
    () =>
      fields
        ?.filter((item) => !["email", "password"].includes(item.name))
        .map((field) => (field.isRequired ? field.name : false))
        .filter((field) => field),
    []
  );

  useEffect(() => {
    if (!isLoading) {
      if (phpError) {
        setError(error);
      }
    }
  }, [data, phpError, isLoading]);

  useEffect(() => {
    setFormData(member);
    setIsApproved(member?.is_approved);
  }, [member]);

  // console.log(formData, member);

  const onSubmit = async (e) => {
    e.preventDefault();
    let shouldProcced = true;

    requiredFields?.map((field) => {
      if (!formData[field]) {
        document.querySelector(`.${field}`).classList.add("field_error");
        setError("Required field missing");
        shouldProcced = false;
      } else {
        document.querySelector(`.${field}`).classList.remove("field_error");
      }
    });

    if (!shouldProcced) {
      return false;
    }

    const data = new FormData();
    Object.keys(formData).forEach((key) => {
      if (!["profile_pic", "signature", "payment_document", "ssc_certificate"].includes(key) && typeof formData[key] === "object") {
        data.append(key, JSON.stringify(formData[key]));
      } else {
        data.append(key, formData[key]);
      }
    });
    window.myFormData = data;

    // { nonce: props.nonce, model: "Users", method: "test" }
    data.append("nonce", nonce);
    data.append("model", "Users");
    data.append("method", "create_account");

    setLoading(true);
    setError(null);

    try {
      const res = await fetch(`${window.location.origin + window._wpUtilSettings.ajax.url}?action=ajax_request_handler&nonce=${nonce}&model=Users&method=create_account`, {
        method: "POST",
        body: data,
      });

      const response = await res.json();
      // eslint-disable-next-line no-console
      console.log({ response });
      setLoading(false);
      if (!response.success) {
        setError(response.data);
        if (!response.success && Array.isArray(response.data?.errors)) {
          response.data?.errors.map((item) => {
            document.querySelector(`.${Object.keys(item)?.[0]}`)?.classList.add("field_error");
          });
        }
        return false;
      }

      setLoading(false);
      setNotice("Approved");
      refetch();
      setTimeout(() => {
        setNotice(null);
        setOpen(false);
      }, 2000);
      // window.location.href = window.location.origin + window.location.pathname + `#mmm_notice`;
      // console.log(window.location.origin + window.location.pathname + `#mmm_notice`);
      const contentContainer = document.querySelector(".contentContainer");
      contentContainer.scrollTop = contentContainer.scrollHeight;
    } catch (error) {
      setLoading(false);
    }
  };

  const handleApproval = () => {
    saveData({ user_id: formData?.user_id, is_approved: true, email: formData?.email, full_name_en: formData?.full_name_en, mobile_no: formData?.mobile_no });

    setTimeout(() => {
      setNotice("Approved");
      setTimeout(() => {
        const contentContainer = document.querySelector(".contentContainer");
        contentContainer.scrollTop = contentContainer.scrollHeight;
        refetch();
      }, 100);
    }, 500);

    setTimeout(() => {
      setNotice(null);
      setOpen(false);
    }, 3000);
  };

  // useEffect(() => {
  //   if (!approval_running) {
  //   }
  //   console.log({ approvalError });
  // }, [approvalError, approval_running]);

  // console.log(auth);
  window.auth = auth;

  return (
    <Modal
      open={open}
      onRequestClose={() => {
        setOpen(false);
        setEditable(false);
      }}
    >
      {editable ? (
        <>
          <RegistrationForm
            editable={editable}
            loading={loading}
            type={!isApproved ? "application" : "approved"}
            error={error}
            fields={[...fields.filter((field) => (auth.role === "administrator" ? !["confirm_password"].includes(field.name) : [""].includes(field.name)))]}
            thanaList={thanaList}
            districtList={districtList}
            formData={formData}
            notice={notice}
            setFormData={setFormData}
            onSubmit={onSubmit}
          />
        </>
      ) : (
        formData?.user_id && <ApplicationForm data={formData} nonce={nonce} page={page} auth={auth} handleApprove={handleApproval} isLoading={isLoading} notice={notice} />
      )}
    </Modal>
  );
};

export default MemberModal;

/*
export const fields = JSON.parse(
  `[{"type":"text","placeholder":"SSC Roll","width":"half_width","label":"SSC Roll","labelPosition":"top","options":[],"isRequired":false,"name":"ssc_roll","dependency":[]},{"type":"select","placeholder":"SSC Year","width":"half_width","label":"SSC Year","labelPosition":"top","options":["1950","1951","1952","1953","1954","1955","1956","1957","1958","1959","1960","1961","1962","1963","1964","1965","1966","1967","1968","1969","1970","1971","1972","1973","1974","1975","1976","1977","1978","1979","1980","1981","1982","1983","1984","1985","1986","1987","1988","1989","1990","1991","1992","1993","1994","1995","1996","1997","1998","1999","2000","2001","2002","2003","2004","2005","2006","2007","2008","2009","2010","2011","2012","2013","2014","2015","2016","2017","2018","2019","2020","2021","2022","2023","2024","2025","2026","2027","2028","2029","2030"],"isRequired":false,"name":"year_of_ssc_exam","dependency":[]},{"type":"text","placeholder":"Name","width":"half_width","label":"Name","labelPosition":"top","options":["Option"],"isRequired":true,"name":"full_name_en","dependency":[]},{"type":"text","placeholder":"Mother's Name","width":"half_width","label":"Mother's Name","labelPosition":"top","options":["Option"],"isRequired":false,"name":"mother_name","dependency":[]},{"type":"text","placeholder":"Father's Name","width":"half_width","label":"Father's Name","labelPosition":"top","options":["Option"],"isRequired":false,"name":"father_name","dependency":[],"dependencies":""},{"type":"date-picker","placeholder":"Date of Birth","width":"half_width","label":"Date of Birth","labelPosition":"top","options":["Option"],"isRequired":false,"name":"date_of_birth","dependency":[],"dependencies":"","previewEnabled":true},{"type":"select","placeholder":"Gender","width":"half_width","label":"Gender","labelPosition":"top","options":["Male","Female"],"isRequired":false,"name":"gender","dependency":[]},{"type":"text","placeholder":"NID No.","width":"half_width","label":"NID No.","labelPosition":"top","options":["Option"],"isRequired":false,"name":"NID_NO","dependency":[]},{"type":"text","placeholder":"Education Qualification","width":"half_width","label":"Education Qualification","labelPosition":"top","options":["Option"],"isRequired":false,"name":"education_qualification","dependency":[]},{"type":"text","placeholder":"Profession","width":"half_width","label":"Profession","labelPosition":"top","options":["Option"],"isRequired":false,"name":"profession","dependency":[]},{"type":"text","placeholder":"School of SSC Exam","width":"half_width","label":"School of SSC Exam","labelPosition":"top","options":["Option"],"isRequired":false,"name":"school_of_ssc_exam","dependency":[]},{"type":"select","placeholder":"Marital Status","width":"half_width","label":"Marital Status","labelPosition":"top","options":["Single","Married"],"isRequired":false,"name":"marital_status","dependency":[]},{"type":"text","placeholder":"Enter Text","width":"half_width","label":"Spouse Name","labelPosition":"top","options":["Option"],"isRequired":false,"name":"spouse_name","dependency":[],"dependencies":"marital_status|Married"},{"type":"childrens","placeholder":"Enter Text","width":"half_width","label":"No. of Children","labelPosition":"top","options":["0","1","2","3","4","5"],"isRequired":false,"name":"no_of_children","dependency":[],"dependencies":"marital_status|Married"},{"type":"address","placeholder":"","width":"full_width","label":"Permanent Address","labelPosition":"top","options":["Option"],"isRequired":false,"name":"permanent_address","dependency":[]},{"type":"address","placeholder":"Enter Text","width":"full_width","label":"Present Address","labelPosition":"top","options":["Option"],"isRequired":false,"name":"present_address","dependency":[]},{"type":"text","placeholder":"Mobile Number","width":"half_width","label":"Mobile Number","labelPosition":"top","options":["Option"],"isRequired":false,"name":"mobile_no","dependency":[]},{"type":"email","placeholder":"Email","width":"half_width","label":"Email","labelPosition":"top","options":["Option"],"isRequired":false,"name":"email","dependency":[]},{"type":"blood-group","placeholder":"Blood Group","width":"half_width","label":"Blood Group","labelPosition":"top","options":["Option"],"isRequired":false,"name":"blood_group","dependency":[]},{"type":"select","placeholder":"Select","width":"half_width","label":"Is registration fee (Tk. 500) paid?","labelPosition":"top","options":["Yes","No"],"isRequired":false,"name":"is_registration_fee_paid","dependency":[],"number_of_column":"column_1"},{"type":"password","placeholder":"Password","width":"full_width","label":"Password","labelPosition":"top","options":["Option"],"isRequired":false,"name":"password","dependency":[]},{"type":"file","placeholder":"Enter Text","width":"full_width","label":"Attachment","labelPosition":"top","options":["Option"],"isRequired":false,"name":"payment_document","dependency":[],"dependencies":"is_registration_fee_paid|Yes"},{"type":"file","placeholder":"Enter Text","width":"full_width","label":"Photo (300x300)","labelPosition":"top","options":["Option"],"isRequired":false,"name":"profile_pic","dependency":[],"previewEnabled":true}]
`
).filter((item) => !["email", "password"].includes(item.name));
*/
// {"type":"switch","placeholder":"Enter Textsdf","width":"full_width","label":"is Approved","labelPosition":"top","options":["Option","new option"],"isRequired":false,"name":"","dependency":[]}
